import { useVentures } from "@/hooks/use-mock-data";

const statusColors: Record<string, string> = {
  planning: "#555",
  building: "#EBF216",
  launched: "#44F2D2",
  growing: "#4B75F2",
  sunset: "#CC2936",
};

export function VenturesSummary() {
  const { data: ventures } = useVentures();

  return (
    <div className="space-y-2.5">
      {ventures.map((v) => {
        const color = statusColors[v.status] ?? "#555";
        return (
          <div key={v.id} className="flex items-center gap-2.5">
            <div
              className="w-2 h-2 rounded-full shrink-0"
              style={{ backgroundColor: color }}
            />
            <span className="text-[13px] text-foreground truncate flex-1">
              {v.name}
            </span>
            <span
              className="text-[10px] uppercase tracking-wider font-brand shrink-0"
              style={{ color }}
            >
              {v.status}
            </span>
          </div>
        );
      })}
    </div>
  );
}
